import React, { useState } from "react";
import { Button, Box, Card, CardContent, Grid, Typography, TextField } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { useDeadline } from "../../../../contexts/DeadlineContext";

const AddWorkshopEmailTitle = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { offButton, abstractHomeSetup } = useDeadline();
    const [disabled, setDisabled] = useState(true);
    const [addEmailTemp, setAddEmailTemp] = useState({
        email_title: "",
        error_list: [],
    });

    const handleInput = (e) => {
        e.persist();
        setAddEmailTemp({ ...addEmailTemp, [e.target.name]: e.target.value });
        validateForm(); // Validate form after every input change
    };

   

    const validateForm = () => {
        const { email_title, } = addEmailTemp;
        if (email_title) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const absAddEmailTempTitle = (e) => {
        e.preventDefault();
        const data = {
            eventid,
            email_title: addEmailTemp.email_title,
            
        };

        axios.get('/sanctum/csrf-cookie').then(() => {
            axios.post(`/api/store-workshop-template-title`, data).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    history.push('/admin/workshop/add-template');
                } else {
                    setAddEmailTemp({ ...addEmailTemp, error_list: res.data.validate_error });
                }
            });
        });
    };

    let backGroundButtonByEvent = eventid ? `${abstractHomeSetup.color_code_two}` : '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000' }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }}>
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick = {()=>{history.goBack()}}>
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Add WorkShop Email Template Title
                        </Typography>
                        <Box component="form" onSubmit={absAddEmailTempTitle} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Email Title"
                                        name='email_title'
                                        onChange={handleInput}
                                        value={addEmailTemp.email_title}
                                        helperText={addEmailTemp.error_list.email_title}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    //disabled={disabled}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent }}
                                >
                                    Add Template
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default AddWorkshopEmailTitle;
